import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as t } from "../../../chunks/tslib.es6.js";
import r from "../../../Graphic.js";
import e from "../../../core/Accessor.js";
import { HandleOwnerMixin as o } from "../../../core/HandleOwner.js";
import { init as s } from "../../../core/watchUtils.js";
import { property as i } from "../../../core/accessorSupport/decorators/property.js";
import "../../../core/arrayUtils.js";
import "../../../core/has.js";
import "../../../core/accessorSupport/ensureType.js";
import { subclass as a } from "../../../core/accessorSupport/decorators/subclass.js";
import { graphicCallback as c } from "../support/featureUtils.js";

var n = /*#__PURE__*/function (_o) {
  _inherits(n, _o);

  var _super = _createSuper(n);

  function n(t) {
    var _this;

    _classCallCheck(this, n);

    _this = _super.call(this, t), _this._loadingPromise = null, _this.created = null, _this.creator = null, _this.destroyer = null, _this.graphic = null, _this.handles.add(s(_assertThisInitialized(_this), "creator", function (t) {
      _this._destroyContent(), _this._createContent(t);
    }));
    return _this;
  }

  _createClass(n, [{
    key: "destroy",
    value: function destroy() {
      this._destroyContent();
    }
  }, {
    key: "state",
    get: function get() {
      return this._loadingPromise ? "loading" : "ready";
    }
  }, {
    key: "_destroyContent",
    value: function _destroyContent() {
      var t = this.created,
          r = this.graphic,
          e = this.destroyer;
      t && (c(e, {
        graphic: r
      }).catch(function () {
        return null;
      }), this._set("created", null));
    }
  }, {
    key: "_createContent",
    value: function () {
      var _createContent2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(t) {
        var r, e, o;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                r = this.graphic, e = c(t, {
                  graphic: r
                }).catch(function () {
                  return null;
                });
                this._loadingPromise = e, this.notifyChange("state");
                _context.next = 4;
                return e;

              case 4:
                o = _context.sent;
                e === this._loadingPromise && (this._loadingPromise = null, this.notifyChange("state"), this._set("created", o));

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function _createContent(_x) {
        return _createContent2.apply(this, arguments);
      }

      return _createContent;
    }()
  }]);

  return n;
}(o(e));

t([i({
  readOnly: !0
})], n.prototype, "created", void 0), t([i()], n.prototype, "creator", void 0), t([i()], n.prototype, "destroyer", void 0), t([i({
  type: r
})], n.prototype, "graphic", void 0), t([i({
  readOnly: !0
})], n.prototype, "state", null), n = t([a("esri.widgets.Feature.FeatureContent.FeatureContentViewModel")], n);
var p = n;
export { p as default };